import colors from 'vuetify/lib/util/colors';

class ThemeManager {
  constructor() {
    this.defaultTheme = {
      primary: colors.blue.darken3,
      secondary: colors.lightBlue.lighten1,
      accent: colors.lightBlue.darken1,
      error: colors.red.base,
      warning: colors.yellow.base,
      info: colors.lightBlue.lighten1,
      success: colors.green.base,
    };
  }

  get currentTheme() {
    return this.defaultTheme;
  }
}

export default new ThemeManager();
